import { convertSecondsToTime } from 'utils/timeHelper';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

const ModuleItem = ({
  clinicTime,
  totalTime,
  isRpm,
}: {
  isRpm: boolean;
  clinicTime?: number;
  totalTime?: number;
}) => {
  const { t } = useTranslation();
  const title = isRpm ? t('labels.rpm') : t('labels.ccm');
  const dataCyModule = isRpm ? 'rpm' : 'ccm';

  return (
    <div className={s['module-wrapper']}>
      <div>
        <p className={s['module-time-title']}>{t('controls.clinic')}</p>
        <div
          className={s['module-time']}
          data-cy={`${dataCyModule}-clinic-interactive-time`}
        >
          {convertSecondsToTime(clinicTime)}
        </div>
      </div>
      <div className={s['module-title']}>{title}</div>
      <div>
        <p className={s['module-time-title']}>{t('controls.total')}</p>
        <div
          className={s['module-time']}
          data-cy={`${dataCyModule}-total-interactive-time`}
        >
          {convertSecondsToTime(totalTime)}
        </div>
      </div>
    </div>
  );
};

export default ModuleItem;
